import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
  SIDE_NAV_DARK,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Lively";
export const STAGING_URL = "https://staging-api.lively.li";
export const PRODUCTION_URL = "https://api.lively.li";
export const API_BASE_URL = PRODUCTION_URL;
export const API_BASE_URL_V2 = PRODUCTION_URL + "/cms";
export const API_BASE_URL_STAGING = PRODUCTION_URL;
export const API_BASE_URL_V2_STAGING = PRODUCTION_URL + "/cms";
export const WEB_SOCKET_URL =
  "wss://253ul4moik.execute-api.ap-south-1.amazonaws.com/production";
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const INTERACTIVE_MAIN_MENU_KEY = "lively_main_menu_interactive_2024";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const LIVE_STREAM_ENTRY = `${APP_PREFIX_PATH}/live-call/stream/schedule`;
export const SHOP_DOMAIN_ENTRY = `${APP_PREFIX_PATH}/shopify/plans`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const LIVELY_LOGO =
  "https://uploads-ssl.webflow.com/6466992f68dcc33a1f55edca/6469805dab8a9b8f10fd9362_Screenshot_2023-05-21_075146-removebg-preview.png";

export const LIVELY_DARK_LOGO =
  "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/lively_pure_black.png";
const currentDomain = window.location.hostname;
const validDomains = ["localhost", "vudio"];
const isVudioDomain = validDomains.some((domain) =>
  currentDomain.includes(domain)
);

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get("redirect") === "livelyCms") {
  localStorage.setItem("redirectedCms", true);
} else {
  localStorage.setItem("redirectedCms", false);
}

if (urlParams.get("companyID")) {
  localStorage.setItem("redirectedCompanyId", urlParams.get("companyID"));
} else {
  localStorage.setItem("redirectedCompanyId", false);
}

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: isVudioDomain ? SIDE_NAV_DARK : SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: isVudioDomain ? "dark" : "light",
  direction: DIR_LTR,
  blankLayout: false,
  secondNavOpen: false,
  vudioSecondNavItems: [],
};

export const FACEBOOK_AUTH_APP_ID = "409736351933885";
export const FACEBOOK_AUTH_CONFIG_ID = "1432399781489984";
export const EVENTS_API_BASE_URL = "https://event.lively.li/api";
export const IS_VUDIO_DASHBOARD = isVudioDomain ? true : false;
export const GRAPH_QL_VERSION = "2025-01";
export const AI_VIDEO_EDITOR_DIY_ID = "overlay-template";